export default __webpack_public_path__ + "static/media/ic_friend_group.a8cea6f9.png";